<template>
  <div class="inputGai">
    <el-time-picker
      v-model="innerValue[0]"
      :format="renderConfig.format"
      :placeholder="renderConfig.placeholder"
      :disabled="renderConfig.disabled"
      :valueFormat="renderConfig.valueFormat"
      style="flex-grow: 1; width: 100%"
      @change="handleChange"
    />
    <span class="separate">-</span>
    <el-time-picker
      v-model="innerValue[1]"
      :format="renderConfig.format"
      :placeholder="renderConfig.placeholder"
      :disabled="renderConfig.disabled"
      :valueFormat="renderConfig.valueFormat"
      :shortcuts="renderConfig.shortcuts"
      style="flex-grow: 1; width: 100%"
      @change="handleChange"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { basicProps } from '@/components/custom/form/components/props'

const props = defineProps({
  ...basicProps
})
const emit = defineEmits(['update:modelValue'])

const innerValue = computed({
  get() {
    return props.modelValue
  },
  set(newVal) {
    emit('update:modelValue', newVal)
  }
})

function handleChange() {
  emit('update:modelValue', innerValue.value)
}
</script>
<style lang="scss" scoped>
.inputGai {
  display: flex;
  align-items: center;
  .separate {
    padding: 0 4px;
  }
}
</style>
